import React, { useEffect, useRef, useState } from "react";
import moment from "jalali-moment";
import { useReactToPrint } from "react-to-print";
import generatePDF from "react-to-pdf";
import { useLocation, useNavigate } from "react-router";
import { digitsThree } from "../../../utils/price";
import { convertOrderBundleProducts } from "../helper/convertOrderBundleProducts";
import { getApi } from "../../../services/api/globalApi";

const PdfAndPrint = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Visitor Pass",
    bodyClass: "rtlDir",
    onAfterPrint: () => console.log("Printed PDF successfully!"),
  });

  const location = useLocation();

  const orderId = new URLSearchParams(location.search).get("orderId");
  const [data, setData] = useState(
    location.state?.products?.length ? location.state : null
  );
  const [loading, setLoading] = useState(Boolean(orderId && !location.state?.products?.length));
  const [error, setError] = useState(orderId ? "" : "اطلاعات سفارش در این لینک موجود نیست. از فهرست سفارش‌ها دوباره وارد شوید.");

  useEffect(() => {
    if (location?.state?.products?.length) {
      setData(location?.state);
      setLoading(false);
      setError("");
      return;
    }
    if (!orderId) {
      setData(null);
      setError("اطلاعات سفارش در این لینک موجود نیست. از فهرست سفارش‌ها دوباره وارد شوید.");
      return;
    }

    let active = true;
    setData(null);
    setLoading(true);
    setError("");
    getApi({ path: `admin/orders/${encodeURIComponent(orderId)}` })
      .then((response) => {
        if (!active) return;
        const order = response?.data?.result;
        if (order?.products?.length) {
          setData(order);
        } else {
          setError("اطلاعات این سفارش برای چاپ یافت نشد.");
        }
      })
      .catch(() => {
        if (active) setError("دریافت اطلاعات سفارش انجام نشد. دسترسی و اتصال خود را بررسی کنید.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [location.state, orderId]);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location?.pathname]);

  const orderInfoRef = useRef();
  const handleOrderInfoPrint = useReactToPrint({
    content: () => orderInfoRef.current,
    documentTitle: "Visitor Pass",
    bodyClass: "rtlDir",
    onAfterPrint: () => console.log("Printed PDF successfully!"),
  });
  const convertedProduct = convertOrderBundleProducts(data?.products || []);
  if (!data) {
    return (
      <div className="mx-auto mt-12 flex w-11/12 max-w-xl flex-col items-center gap-4 rounded-xl bg-white p-8 text-center shadow">
        <p className="text-gray-700">{loading ? "در حال دریافت اطلاعات سفارش..." : error}</p>
        {!loading && <button type="button" onClick={() => navigate(-1)} className="rounded-lg bg-blue-700 px-4 py-2 text-white">بازگشت</button>}
      </div>
    );
  }
  return (
    <div className="w-[1024px] mx-auto h-auto py-10 bg-white">
      <div className="flex items-center justify-between px-4">
        <div className="w-11/12 flex gap-3 items-center mx-auto">
          <button
            onClick={handlePrint}
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            پرینت سفارش
          </button>
          <button
            onClick={handleOrderInfoPrint}
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            پرینت اطلاعات ارسال
          </button>
          <button
            onClick={() => generatePDF(componentRef, { filename: "page.pdf" })}
            type="button"
            className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          >
            دانلود PDF
          </button>
        </div>
        <p
          onClick={() => navigate(-1)}
          className="cursor-pointer focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
        >
          بازگشت
        </p>
      </div>
      <div className="w-full p-4">
        <div ref={componentRef} className="w-full overflow-hidden">
          <div className="w-full flex justify-between p-4">
            <div className="flex items-cneter justify-center w-48">
              <p>
                <img
                  className="w-20 py-2"
                  src={require("./../../../assets/image/logo.png")}
                  alt="website-logo"
                />
              </p>
            </div>
            <div className="text-xl text-gray-800 b-titr">
              فروشگاه آکادمی هنری مینا
            </div>
            <div className="flex flex-col w-48 text-gray-800 text-sm justify-center gap-1 b-titr">
              <p>
                تاریخ :{" "}
                {moment(data?.paymentDate).locale("fa").format("YYYY/M/D")}
              </p>
              <p>شماره فاکتور : #{data?.trackingCode}</p>
              <p>تلفن فروشگاه : 01134569856</p>
            </div>
          </div>

          <h3 className="px-2 text-gray-800 w-full text-center mb-2">
            مشخصات کالا
          </h3>
          <div className="w-full px-8">
            <div className="flex flex-col">
              <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full border border-neutral-300 text-center text-sm font-light text-surface dark:border-white/10 dark:text-white">
                      <thead className="border-b border-neutral-300 font-medium dark:border-white/10">
                        <tr>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            ردیف
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            شرح کالا
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            تعداد
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            مبلغ واحد {`(تومان)`}
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            مبلغ کل {`(تومان)`}
                          </th>
                          {/* <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            درصد تخفیف
                          </th> */}
                          {/* <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            مبلغ نهایی {`(تومان)`}
                          </th> */}
                          <th scope="col" className="px-6 py-4">
                            QC
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {convertedProduct?.map((item, index) => {
                          return (
                            <tr className="border-b border-neutral-300 dark:border-white/10">
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 font-medium dark:border-white/10">
                                {index + 1}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {item.productName}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {item.count}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {!item.inPack
                                  ? digitsThree(item.basePrice)
                                  : "محاسبه شده در پک"}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {!item.inPack
                                  ? digitsThree(item.totalPrice)
                                  : "محاسبه شده در پک"}
                              </td>
                              {/* <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {!item.inPack ? item.discountPercent : ""} %
                              </td> */}
                              {/* <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {!item.inPack ? digitsThree(item.finalPrice) : "محاسبه شده در پک"}
                              </td> */}
                              <td className="whitespace-nowrap px-6 py-4 flex justify-center items-center">
                                <div className="border w-4 h-4 border-gray-600 rounded-sm"></div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    <div className="flex justify-between gap-4 p-4 px-10 w-full border mt-4 text-gray-800">
                      <div className="flex flex-col gap-4">
                        <p>
                           وضعیت: تایید شده
                        </p>

                        <p>
                          مجموع قیمت کالا :{" "}
                          {digitsThree(data?.finalProductsPrice)} تومان
                        </p>
                      </div>
                      <div className="flex flex-col gap-4">
                        <p>
                          هزینه ارسال :{" "}
                          {data?.shippingFinalPrice
                            ? `${digitsThree(data?.shippingFinalPrice)} تومان`
                            : "رایگان"}
                        </p>
                        <p>
                          مجموع پرداختی : {digitsThree(data?.finalPrice)} تومان
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-3 border-t border-b boder-gray-900 py-2"></div>
        <div ref={orderInfoRef} className="w-full px-2 py-4">
          <h3 className="px-2 text-gray-800">اطلاعات مشتری</h3>
          <div className="flex flex-col gap-3 text-gray-700 py-4">
            <div className="flex px-4 iems-center gap-4">
              <p className="w-6/12 text-md">
              نام و نام خانوادگی : {data?.name} {data?.userRole ==="affiliate" ? " ***" : null}
              </p>
              <p className="w-6/12 text-md">شماره تماس : {data?.mobile}</p>
            </div>
            <div className="flex px-4 iems-center gap-4">
              <p className="w-6/12 text-md">کد پستی : {data?.postcode}</p>
              <p className="w-6/12 text-md">
                استان : {data && `${data?.province}`}
              </p>
            </div>
            <div className="flex px-4 iems-center gap-4">
              <p className="w-6/12 text-md">شهر : {data && `${data?.city}`}</p>
              <p className="w-6/12 text-md">
                آدرس : {data && `${data?.address} `}
              </p>
            </div>
            <div className="flex px-4 iems-center gap-4">
              <p className="w-full text-md">
                توضیحات : {data && `${data?.description || "-"} `}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PdfAndPrint;
